/* MADES: product card videos.
   Desktop (mouse): play on hover. Phones/tablets (touch): the large cards play automatically
   while on screen (muted, inline). Video fades in only once it is actually playing. */
(function () {
  var SEL = '.card-gallery, .mades-pc__media';
  var VIDEO = '.mades-card-hover-video video, .mades-pc__video video';

  function prep(v) {
    v.muted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
  }

  function start(box, v) {
    prep(v);
    box.dataset.madesOn = '1';
    v.addEventListener('playing', function () {
      if (box.dataset.madesOn === '1') box.classList.add('is-playing');
    }, { once: true });
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {});
  }

  function stop(box, v, rewind) {
    box.dataset.madesOn = '';
    box.classList.remove('is-playing');
    v.pause();
    if (rewind) { try { v.currentTime = 0; } catch (err) {} }
  }

  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (canHover) {
    document.addEventListener('pointerenter', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var box = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!box || box.dataset.madesOn === '1') return;
      var v = box.querySelector(VIDEO);
      if (!v) return;
      try { v.currentTime = 0; } catch (err) {}
      start(box, v);
    }, true);

    document.addEventListener('pointerleave', function (e) {
      var box = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!box || e.target !== box) return;
      var v = box.querySelector(VIDEO);
      if (v) stop(box, v, true);
    }, true);
    return;
  }

  // Touch: autoplay only on large cards (wider than ~60% of the screen) that are mostly visible.
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var box = en.target;
      var v = box.querySelector(VIDEO);
      if (!v) return;
      var big = box.getBoundingClientRect().width > window.innerWidth * 0.6;
      if (en.isIntersecting && big) start(box, v);
      else if (box.dataset.madesOn === '1') stop(box, v, false);
    });
  }, { threshold: 0.6 });

  function scan() {
    document.querySelectorAll(SEL).forEach(function (box) {
      if (box.dataset.madesWatched || !box.querySelector(VIDEO)) return;
      box.dataset.madesWatched = '1';
      io.observe(box);
    });
  }
  scan();
  // Infinite scroll / tab switches add cards later.
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 300); }).observe(document.documentElement, { childList: true, subtree: true });
})();
